<app-page-header
    title="Settings"
    [breadcrumbs]="breadcrumbs"
    [buttons]="buttons"
></app-page-header>

<div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <div class="settings-layout">
                <!-- Vertical sidebar tab navigation -->
                <mat-nav-list class="settings-sidebar">
                    <a
                        mat-list-item
                        *appCan="'edit_tenant_settings'"
                        [class.settings-tab-active]="selectedTab == 0"
                        (click)="changeTab(0)"
                    >
                        Organisation
                    </a>
                    <a
                        mat-list-item
                        *appCan="'view_roles'"
                        [class.settings-tab-active]="selectedTab == 1"
                        (click)="changeTab(1)"
                    >
                        Roles
                    </a>
                    <a
                        mat-list-item
                        *appCan="'view_settings'"
                        [class.settings-tab-active]="selectedTab == 2"
                        (click)="changeTab(2)"
                    >
                        System Settings
                    </a>
                    <a
                        mat-list-item
                        *appCan="'view_credit_logs'"
                        [class.settings-tab-active]="selectedTab == 3"
                        (click)="changeTab(3)"
                    >
                        Credit Logs
                    </a>
                </mat-nav-list>

                <!-- Tab content area -->
                <div class="settings-content">
                    @switch (selectedTab) { @case (0) {
                    <app-organisation-settings
                        *appCan="'edit_tenant_settings'"
                    ></app-organisation-settings>
                    } @case (1) {
                    <ng-container *appCan="'view_roles'">
                        @if (!activeRole) {
                        <app-roles></app-roles>
                        } @else {
                        <app-role-edit [roleData]="activeRole"></app-role-edit>
                        }
                    </ng-container>
                    } @case (2) {
                    <app-system-settings
                        *appCan="'view_settings'"
                    ></app-system-settings>
                    } @case (3) {
                    <app-credit-logs
                        *appCan="'view_credit_logs'"
                    ></app-credit-logs>
                    } }
                </div>
            </div>
        </div>
    </div>
</div>
